import React from "react";

import {CardOverflow, TabList, TabPanel, Tabs} from "@mui/joy";
import Card from "@mui/joy/Card";
import Stack from "@mui/joy/Stack";
import CardContent from "@mui/joy/CardContent";
import Tab, {tabClasses} from "@mui/joy/Tab";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Box from "@mui/joy/Box";

// components
import CommentSidebar from "../Comment/CommentSidebar";


class CommonModalInner extends React.Component {
    render() {
        return (
            <Box
                sx={{
                    overflowY: 'scroll',
                    width: 'calc(80vw)',
                    height: 'calc(80vh)',
                    pr: 2
                }}
            >
                <Stack
                    direction={'row'}
                    spacing={2}
                    sx={{
                        height: '100%',
                    }}
                >
                    <Stack
                        sx={{
                            height: '100%',
                            flexGrow: 3,
                        }}
                    >
                        <Card
                            orientation={'horizontal'}
                            size={'sm'}
                        >
                            <CardOverflow
                                variant='soft'
                                color={this.props.headerOverflowColor}
                                sx={{
                                    px: 0.2,
                                    writingMode: 'vertical-lr',
                                    transform: 'rotate(180deg)',
                                    textAlign: 'center',
                                    fontSize: 'xs',
                                    fontWeight: 'xl',
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase',
                                    borderLeft: '1px solid',
                                    borderColor: 'divider',
                                }}
                            >
                                {this.props.headerOverflowTitle}
                            </CardOverflow>
                            <CardContent>
                                {this.props.headerComponent}
                            </CardContent>
                        </Card>
                        <Tabs
                            // variant='soft'
                            orientation={'horizontal'}
                            aria-label='Placement indicator tabs'
                            defaultValue={this.props.defaultTabValue}
                            sx={{
                                gridColumn: '1/-1',
                                flexDirection: 'column',
                                borderRadius: 'var(--joy-radius-md);',
                                mt: 1,
                                minHeight: '250px',
                                // height: 'calc(100vh - 250px)',
                            }}
                        >
                            <TabList
                                disableUnderline
                                sx={{
                                    p: 0.5,
                                    gap: 0.5,
                                    borderRadius: 'md',
                                    bgcolor: 'background.level1',
                                    [`& .${tabClasses.root}[aria-selected="true"]`]: {
                                        boxShadow: 'sm', bgcolor: 'background.surface',
                                    },
                                }}
                            >
                                {this.props.tabComponents.filter((each) => !each.hidden).map(each => {
                                    return (
                                        <Tab
                                            disableIndicator
                                            value={each.value}
                                        >
                                            <ListItemDecorator>
                                                {each.icon}
                                            </ListItemDecorator>
                                            {each.title}
                                        </Tab>
                                    )
                                })}
                            </TabList>
                            {this.props.tabComponents.filter((each) => !each.hidden).map(each => {
                                return (
                                    <TabPanel
                                        value={each.value}
                                        variant={'soft'}
                                        sx={{
                                            mt: 1, borderRadius: 'md', overflow: 'auto',
                                        }}
                                    >
                                        {each.component}
                                    </TabPanel>
                                )
                            })}
                        </Tabs>
                    </Stack>
                    <Stack
                        sx={{
                            height: '100%',
                            width: '40%',
                        }}
                    >
                        <CommentSidebar
                            appName={this.props.appName}
                            appId={this.props.appId}
                        />
                    </Stack>
                </Stack>

            </Box>
        )
    }
}

export default CommonModalInner